var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "d-block"
  }, [_c('mdm-icon', {
    staticClass: "icon icon-item sav",
    attrs: {
      "name": "sav"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('footer.customer_service')))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-normal",
    domProps: {
      "textContent": _vm._s(_vm.localServiceNumber)
    }
  })], 1), _vm._v(" "), _c('MdmLink', {
    staticClass: "d-none",
    attrs: {
      "url": "https://faq-france.maisonsdumonde.com/",
      "is-scramble-link": _vm.isScrambleLink
    }
  }, [_c('mdm-icon', {
    staticClass: "icon icon-item sav",
    attrs: {
      "name": "sav"
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Aide et contact")])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };